import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { MentionsInput, Mention } from "react-mentions";
import { useFormContext } from "./Form";
import { withFormWrapper, DEFAULT_ID } from "./withFormWrapper";
import { StaticInputValue } from "./StaticInput";
import { useTranslation } from "./hooks/useTranslation";
const RawMention = observer(({ name, onChange, trigger = "{", options, type, placeholder, disabled = false, singleLine = true, uniqueId = DEFAULT_ID, label, staticFormatter, dataId, dataLabel, dataTestId, }) => {
    const { values, isStatic } = useFormContext();
    const sortedOptions = options.sort((a, b) => a.display.localeCompare(b.display));
    const markup = type === "jinja" ? "{{__id__}}" : "__display__ ";
    const regex = /@(\S+)/;
    const emptyStringIfNull = (value) => {
        return value !== null ? value : "";
    };
    const getDisplayValue = (id, display) => {
        if (type === "jinja") {
            return `{{${id}}}`;
        }
        return display;
    };
    const handleChange = useCallback((value) => {
        onChange(value, values.get(name));
        values.set(name, value);
    }, [onChange, values, name]);
    const onAdd = () => {
        values.set(name, removeSpacesBetweenBraces(values.get(name)));
    };
    const removeSpacesBetweenBraces = (value) => {
        return value.replace(/\}.*?\{/g, (value) => {
            return value.replace(/\s/g, "");
        });
    };
    if (isStatic) {
        return (React.createElement(StaticInputValue, { label: label, name: name, staticFormatter: staticFormatter, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    const t = useTranslation();
    return (React.createElement(MentionsInput, { className: `mentions ${singleLine ? "single" : ""}`, "aria-label": t("Mention"), value: emptyStringIfNull(values.get(name)), placeholder: placeholder, allowSpaceInQuery: true, disabled: disabled, onChange: (_, newValue) => handleChange(newValue), id: `form-group-${name}-${uniqueId}` },
        React.createElement(Mention, { trigger: trigger, data: sortedOptions, markup: markup, regex: regex, displayTransform: (id, display) => getDisplayValue(id, display), onAdd: onAdd, appendSpaceOnAdd: true })));
});
export const MentionInput = withFormWrapper({ WrappedComponent: RawMention });
